
const getData = require("../../components/getData/getData");
let xzjeInput = "";
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份   
        "d+": this.getDate(),                    //日   
        "H+": this.getHours(),                   //小时   
        "m+": this.getMinutes(),                 //分   
        "s+": this.getSeconds(),                 //秒   
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
        "S": this.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}


var S = {
    request: null,
    intervalTime: null,
    intervalOpenTime: null,
    initialization: null,
    scrollinterval: null,
    stop: true,
    lineStop: true,
    loadingWrap: true,
    backList: [],
    action: "/totaldata/action.ashx",
    loginDefautl: "/login/?e=" + +new Date()
};

var _INI_ = {

    //弹出对话框容器
    alertHtm: "<div id='myWarpr_alert'>"
        + "<table class='myLayer' cellspacing='0' cellpadding='0' border='0'>"
        + "<tbody>"
        + "<tr>"
        + "<td>"
        + "<div class='myLayerOn'></div>"
        + "<div class='myLayerTitle'><h3></h3><a href='javascript:;' class='myLayerClose' title='關閉'></a></div>"
        + "<div class='myLayerContent' style='width:auto;height:auto;'></div>"
        + "<div class='myLayerFooter'><a href='javascript:;' class='btn grayBtn myLayerCancel' title='取消'>取消</a><a href='javascript:;' class='btn hotBtn myLayerOk' title='确认'>确认</a></div><div class='myLayerLoading'></div>"
        + "</td></tr></tbody></table></div>"

};

var G = {
    alert: function (msg) {
        $("#myWarpr_alert").remove();
        $("body").append(_INI_.alertHtm);
        var myobj = $("#myWarpr_alert");
        var title = msg.title || "提示";
        var content = msg.content || "";
        var width = msg.width || "auto";
        var height = msg.height || "auto";
        var initialize = msg.initialize || false;
        var cancel = msg.cancel || false;
        var ok = msg.ok || false;
        var close = msg.close || false;
        var okVal = msg.okVal || "确认";
        var cancelVal = msg.cancelVal || "取消";
        var lock = true;
        var top, left;

        myobj.find(".myLayerTitle h3").html(title);
        myobj.find(".myLayerContent").html(content);
        myobj.find(".myLayerFooter").hide();
        if(msg.type == 1100){
            myobj.find(".myLayerFooter a.myLayerCancel").html(cancelVal).attr("title", cancelVal);
        }else{
            myobj.find(".myLayerFooter a.myLayerCancel").hide();
        }
        myobj.find(".myLayerFooter a.myLayerOk").html(okVal).attr("title", okVal).hide();

        if (lock) { //遮罩层
            $("#mymask").remove();
            $("body").append("<div class='myLayerLoading' id='mymask'></div>");
            $("#mymask").show();
        }
        if (msg.obj) {
            var obj = msg.obj;
            var elmOffset = obj.offset();
            top = "unset"; //控件top坐標
            left = "unset"; //控件left坐標
        } else {
            myobj.find(".myLayerOn").hide();
            myobj.find(".myLayerContent").css({ "width": width, "height": height, "overflow-y": "auto" });
            var myWidth = myobj.find(".myLayerContent").width();
            var myHieht = myobj.find(".myLayerContent").height();
            top = ($(window).height() - myHieht) / 2.8;
            left = ($(window).width() - myWidth) / 2;
            $(window).resize(function () {

                setTimeout(() => {
                    // myobj.find(".myLayer").css({ "margin-left": -document.getElementById("myWarpr_alert").getElementsByClassName("myLayer")[0].offsetWidth / 2 + "px", "top": "34vh" });
                    myobj.find(".myLayer").css({ "top": "34vh" });
                    $("#mymask").css("height", $(window).height());
                }, 1000)
            });
        }

        // myobj.find(".myLayer").css({ "top": "34vh", "margin-left": -document.getElementById("myWarpr_alert").getElementsByClassName("myLayer")[0].offsetWidth / 2 + "px" });
        myobj.find(".myLayer").css({ "top": "34vh"});
        window.scrollTo(0, 0);

        if (ok) {
            myobj.find(".myLayerFooter").show();
            myobj.find(".myLayerFooter a.myLayerOk").show().focus();
        }
        if (cancel) {
            myobj.find(".myLayerFooter").show();
            myobj.find(".myLayerFooter a.myLayerCancel").show();
        }
        if (initialize) {
            initialize(myobj);
        }
        myobj.find(".myLayerClose").unbind("click").click(function () {
            if (close) { close(); }
            G.alertClose();
        });
        myobj.find(".myLayerCancel").unbind("click").click(function () {
            if (close) { close(); }
            // if (!cancel) {
                G.alertClose();
            // }
        });
        myobj.find(".myLayerOk").unbind("click").click(function () {
            if (ok()) { G.alertClose(); }
            if (close) { close(); }
        });
    },
    alertClose: function () {
        $("#myWarpr_alert").remove();
        $("#mymask").remove();
        $("#myxTips").remove();

    },

    mask: function () {

        $("#mask-eah").remove();
        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerLoading' id='mask-eah'></div>");
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
        $("#mask-eah").show();
    },
    maskClose: function () {

        $("#mask-eah").remove();
        $("#myLayerImg").remove();
    },
    myLayerImg: function () {

        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
    },
    myLayerImgClose: function () {

        $("#myLayerImg").remove();
    },

    isAction: function (msg) {
        for (var i = 0; i < msg.ary.length; i++) {
            if (msg.key === msg.ary[i]) {
                return true;
                break;
            }
        }
    },
    strToObj: function (str) {
        var mystr = str.split("&"), s;
        var data = ["\"__\":\"" + mystr[0] + "\""];
        for (var i = 1; i < mystr.length; i++) {
            if (mystr[i]) {
                s = mystr[i].split("=");
                data.push("\"" + s[0] + "\":\"" + s[1] + "\"");
            }
        }
        return eval("({" + data.join(",") + "})");
    },

    myTips: function (msg) {

        var content = msg.content;
        var elmOffset = msg.obj.offset();
        var _top = msg.top || 3;
        var _left = msg.left || 10;
        var top = "280"; //控件top坐標
        var left = "1055"; //控件left坐標
        var myDiv = "<div id='myxTips' style='left:" + left + "px; top:" + top + "px;'><div id='myxTipsLeft'></div><div id='myxTipsContent'>" + content + "</div></div>";
        $("#myxTips").remove();
        $("body").append(myDiv);
        if (msg.myclick) {
            var count = 0;
            $("body").unbind("click").click(function () {
                count++;
                if (count > 1) {
                    $("#myxTips").remove();
                    $("body").unbind("click");
                }
            });
        } else {
            setTimeout(() => {
                $("#myxTips").remove();
            }, 2000);
        }
    },
    removeTips: function () {
        $("#myxTips").remove();
    },

    ajax: function (data_action, callBack, errorBack) {
        return $.ajax({
            type: "post",
            url: data_action.split("&")[0],
            cache: false,
            timeout: 1000 * 30,
            dataType: 'json',
            data: G.strToObj(data_action),
            success: function (msg) {
                try {
                    if (msg.error) {
                        if (msg.error == "SystemMaintenance") {
                            location.href = S.loginDefautl;
                        } else {
                            if (errorBack) errorBack();
                            G.alert({ content: msg.error, ok: function () { return true; } });
                        }
                    } else {
                        if (callBack) {
                            callBack(msg);
                        }
                    }
                } catch (e) { if (errorBack) errorBack(); }
            }, error: function () {
                if (errorBack) errorBack();
                //G.alert({ content: "Error：the options for this ajax request", ok: function () { return true; } });
            }
        });
    },

    //鼠标经过方法
    mouseover: function (str, hover) {
        var obj = $(str);
        $(obj).mouseover(function () {
            var _hover = hover || "myqhs";
            $(this).addClass(_hover).mouseout(function () {
                $(this).removeClass(_hover);
            });
        });
    },

    //Url参数替换
    urlReplace: function (msg) {
        var oUrl = msg.url || "";
        var paramName = msg.paramName || "page";
        var val = msg.val || "";
        var pad = msg.pad;
        var re = new RegExp("(/\?|&)" + paramName + "=([^&]+$)|" + paramName + "=[^&]+&", "i");
        var nUrl = oUrl.replace(re, '');
        if (pad == true) { //替换原有参数
            var _a = nUrl.indexOf("?") === -1 ? "?" : "&";
            return nUrl + _a + paramName + "=" + val;
        } else { //删除原有参数并返回
            return nUrl;
        }
    },
    //解析Url参数
    query: function (name, referrer) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var _referrer = referrer || location.href;
        var r = decodeURI(_referrer).split("?")[1].match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    },

    //Dight 格式化浮点数 How 保留位数
    forDight: function (Dight, How) {
        Dight = Dight * How;
        return Dight;

    },

    //强制保留小数 How保留位数
    toDecimal: function (Dight, How) {
        if (isNaN(parseFloat(Dight))) {
            return false;
        }
        var f = Math.round(Dight * 100) / 100;
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + How) {
            s += '0';
        }
        return s;
    },

    //写cookies
    setCookie: function (name, value) {
        var Days = 10;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    },

    //读cookies
    getCookie: function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    },

    //删cookies
    delCookie: function (name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = comm.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    //浮点数或正整数
    DecimalSign: function (str) {
        return /^[0-9]+(\.[0-9]+)?$/.test(str);
    },

    //正整数
    NumberSign: function (str) {
        return /^[0-9]+$/.test(str);
    },

    clearNoNum: function (obj) {
        obj.val(obj.val().replace(/[^\d.]/g, "")); //清除“数字”和“.”以外的字符
        obj.val(obj.val().replace(/^\./g, "")); //验证第一个字符是数字而不是.
        obj.val(obj.val().replace(/\.{2,}/g, ".")); //只保留第一个. 清除多余的.
        obj.val(obj.val().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')); //只能输入两个小数
        obj.val(obj.val().replace(".", "$#$").replace(/\./g, "").replace("$#$", "."));
    },

    //可带正负号的正整数
    NumberSignt: function (str) {
        return /^[+-]?[0-9]+$/.test(str);
    },

    //中文或字符串或数字
    ChznSign: function (str) {
        return /^[a-zA-Z0-9-\u4e00-\u9fa5]+$/.test(str);
    },

    //是否是英文字母或数字或_的字符串{0,50}（不允许下划线开始）
    StringSign: function (str) {
        return /^[a-z0-9A-Z][a-z0-9A-Z_]{0,50}$/.test(str);
    },

    //移除數組中的重複值
    AryMethod: function (ary) {
        var h = {};    //定义一个hash表  
        var arr = [];  //定义一个临时数组  
        for (var i = 0; i < ary.length; i++) {    //循环遍历当前数组  
            //对元素进行判断，看是否已经存在表中，如果存在则跳过，否则存入临时数组  
            if (!h[ary[i]]) {
                //存入hash表  
                h[ary[i]] = true;
                //把当前数组元素存入到临时数组中  
                arr.push(ary[i]);
            }
        }
        return arr;
    },

    //滾動軸DIV
    overflowDiv: function (msg) {
        var id = msg.id || +new Date();
        var height = msg.height || 280;
        var content = msg.content || "加载中...";
        return "<div id='" + id + "' style='max-height:" + height + "px; overflow-y:auto;'>" + content + "</div>";
    },

    //分页查询
    searchPage: function ($this, currentPage, totalPage) {
        var pageIndex = false;
        var id = $this.attr("id");
        var current_page = currentPage || parseInt($("#shell_pageControl .pager #currentPage").html()); //当前第几页
        var total_page = totalPage || parseInt($("#shell_pageControl .pager #totalPage").html()); //总页数
        if (id == "first" && current_page > 1) { //第一页
            pageIndex = 1;
        } else if (id == "previous" && current_page > 1) { //上一页
            pageIndex = current_page - 1;
        } else if (id == "next" && total_page > current_page) { //下一页
            pageIndex = current_page + 1;
        } else if (id == "last" && total_page > current_page) { //最后一页
            pageIndex = total_page;
        }
        return pageIndex;
    },

    //时间戳转换HH:mm:ss
    settimes: function (time) {
        if (time > 0 && G.NumberSign(time)) {
            time = parseInt(time);
            var MinutesRound = Math.floor(time / 60);
            var SecondsRound = Math.floor(time - (60 * MinutesRound));
            var Minutes = MinutesRound.toString().length <= 1 ? "0" + MinutesRound : MinutesRound;
            var Seconds = SecondsRound.toString().length <= 1 ? "0" + SecondsRound : SecondsRound;
            var strtime = Minutes + ":" + Seconds;
            return strtime;
        } else {
            return "00:00";
        }
    },
    settimer: function (time) {
        if (time > 0 && G.NumberSign(time)) {
            var days = Math.floor(time / 1440 / 60);
            var hours = Math.floor((time - days * 1440 * 60) / 3600);
            var minutes = Math.floor((time - days * 1440 * 60 - hours * 3600) / 60);
            var seconds = (time - days * 1440 * 60 - hours * 3600 - minutes * 60);
            hours = hours.toString().length == 1 ? "0" + hours : hours;
            minutes = minutes.toString().length == 1 ? "0" + minutes : minutes;
            seconds = seconds.toString().length == 1 ? "0" + seconds : seconds;
            return hours + ":" + minutes + ":" + seconds;
        } else {
            return "00:00:00";
        }
    },

    //加载条
    scrollLoad: function (msg) {
        var defaults = {
            top: msg.top || "98px",
            left: msg.left || "0",
            backColor: msg.backColor || "blue",
            width: msg.width || "0px",
            height: msg.height || "5px",
            display: msg.display || "block",
            scrollStart: msg.scrollStart || 0,
            scrollLneght: msg.scrollLneght || $(window).width() - 10,
            second: msg.second || 1,
            increase: msg.increase || 0.7,
            addDiv: msg.addDiv || "Yes"
        };
        if (defaults.addDiv == "Yes") {
            (function () {
                var newDiv = "<div class='loadScroll' id='LoadScroll'";
                newDiv += "style='";
                newDiv += "position:absolute;";
                newDiv += "top:" + defaults.top + ";";
                newDiv += "left:" + defaults.left + ";";
                newDiv += "width:" + defaults.width + ";";
                newDiv += "max-width:" + (defaults.scrollLneght - 20) + "px;";
                newDiv += "height:" + defaults.height + ";";
                newDiv += "'></div>";
                $("body").append(newDiv);
            })();
        }
        var scrollStart = defaults.scrollStart;
        var scrollLneght = defaults.scrollLneght;
        var resize;
        clearInterval(S.scrollinterval);
        S.scrollinterval = setInterval(function () {
            scrollStart = scrollStart + defaults.increase;
            scrollLneght = scrollLneght - defaults.increase;
            if (!msg.back) //递增
                $("#LoadScroll").css("width", scrollStart + "px");
            else //递减
                $("#LoadScroll").css("width", scrollLneght + "px");

            if ((!msg.back && scrollStart > defaults.scrollLneght) || (msg.back && scrollLneght < 0)) {
                clearInterval(S.scrollinterval);
                if (msg.remove) {
                    setTimeout(function () { $("#LoadScroll").remove(); }, 300);
                }
            }
        }, defaults.second);
    },
    //加载数据异常，数据回滚
    rollBack: function () {
        var scrollLneght = $("#LoadScroll").width();
        var increase = 50;
        var second = 10;
        setTimeout(function () {
            G.scrollLoad({ scrollLneght: scrollLneght, increase: increase, second: second, addDiv: "No", back: true, remove: true });
        }, 500);
    },

    //加载完成
    loadEnd: function () {
        var scrollStart = $("#LoadScroll").width();
        var increase = 90;
        G.scrollLoad({ scrollStart: scrollStart, increase: increase, addDiv: "No", remove: true });
    },

    //驗證密碼
    safety: function (pwd) {
        //判斷密碼是是否合法（合法返回True）
        var Num1 = '123456789';
        var Num2 = '987654321';
        var rex1 = /[0-9]+/g;
        var rex2 = /[a-z]+/g;
        var t_PWD = pwd;
        var PWD_Legality = true;
        var t_PWD_str = t_PWD.toLowerCase();

        var resx1 = /^[0-9]+$/g;
        if (resx1.test(t_PWD_str)) PWD_Legality = false;
        resx1 = /^[a-z]+$/g;
        if (resx1.test(t_PWD_str)) PWD_Legality = false;

        // var strs1 = t_PWD_str.match(rex1);
        // if (strs1 != null) {
        //     for (var i = 0; i < strs1.length; i++) {
        //         if (strs1[i].length > 3) {
        //             if (Num1.indexOf(strs1[i]) != -1)
        //                 PWD_Legality = false; //数字顺序
        //             if (Num2.indexOf(strs1[i]) != -1)
        //                 PWD_Legality = false; //数字倒序
        //         }
        //     }
        // }
        // strs1 = t_PWD_str.match(rex2);
        // if (strs1 != null) {
        //     if (strs1.length == 1) {
        //         if (strs1[0].length == 1)
        //             PWD_Legality = false;
        //     } //只有一个字母
        // }
        //
        // for (var i = 0; i < t_PWD_str.length - 2; i++) {
        //     if (t_PWD_str.charAt(i) == t_PWD_str.charAt(i + 1)) {
        //         if (t_PWD_str.charAt(i) == t_PWD_str.charAt(i + 2)) {
        //             PWD_Legality = false;
        //         }
        //     }
        // }



        return PWD_Legality;
    },

    //RMB显示中文
    toRmb: function (value) {
        var whole = value || $("#Credits").val(), num, dig;
        if (!/^[0-9]*[1-9][0-9]+$/.test(whole) && whole != "") return;
        if (whole.indexOf(".") == -1) {
            num = whole;
            dig = "";
        }
        else {
            num = whole.substr(0, whole.indexOf("."));
            dig = whole.substr(whole.indexOf(".") + 1, whole.length);
        }

        var i = 1;
        var len = num.length;
        var dw2 = new Array("", "萬", "億");
        var dw1 = new Array("十", "百", "千");
        var dw = new Array("", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var k1 = k2 = 0, str = "";

        for (i = 1; i <= len; i++) {
            var n = num.charAt(len - i);
            if (n == "0") {
                if (k1 != 0)
                    str = str.substr(1, str.length - 1);
            }

            str = dw[Number(n)].concat(str);

            if (len - i - 1 >= 0) {
                if (k1 != 3) {
                    str = dw1[k1].concat(str);
                    k1++;
                }
                else {
                    k1 = 0;
                    var temp = str.charAt(0);
                    if (temp == "萬" || temp == "億")
                        str = str.substr(1, str.length - 1);
                    str = dw2[k2].concat(str);
                }
            }
            if (k1 == 3)
                k2++;
        }
        if (str.length >= 2)
            if (str.substr(0, 2) == "一十") str = str.substr(1, str.length - 1);
        //document.getElementById(sName).innerHTML = str;
        return str;
    },

    //HK 3色球
    contains: function (num) {
        var red = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
        var blue = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
        var green = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
        for (var i = 0; i < red.length; i++) {
            if (red[i] == num) {
                return "red";
            }
        }
        for (var i = 0; i < blue.length; i++) {
            if (blue[i] == num) {
                return "bluer";
            }
        }
        for (var i = 0; i < green.length; i++) {
            if (green[i] == num) {
                return "green";
            }
        }
    },

    //GX 3色球
    contains_gx: function (num) {
        var red = [1, 4, 7, 10, 13, 16, 19];
        var blue = [2, 5, 8, 11, 14, 17, 20];
        var green = [3, 6, 9, 12, 15, 18, 21];
        for (var i = 0; i < red.length; i++) {
            if (red[i] == num) {
                return "red";
            }
        }
        for (var i = 0; i < blue.length; i++) {
            if (blue[i] == num) {
                return "bluer";
            }
        }
        for (var i = 0; i < green.length; i++) {
            if (green[i] == num) {
                return "green";
            }
        }
    },

    /// <summary>
    /// 复式计算，0返回总列表List、1总组数
    /// </summary>
    /// <param name="cycle">循环次数</param>
    /// <param name="ary">循环数组</param>
    /// <returns>{list:数组,count:总组数}</returns>
    DuplexSum: function (cycle, ary) {
        var list = [];
        var len = ary.length, _count = 0;
        for (var a = 0; a < len; a++) {
            var _a = a + 1;
            for (var b = _a; b < len; b++) {
                if (cycle == 2) {
                    _count++;
                    list.push(ary[a] + "," + ary[b]);
                    continue;
                }
                var _b = b + 1;
                for (var c = _b; c < len; c++) {
                    if (cycle == 3) {
                        _count++;
                        list.push(ary[a] + "," + ary[b] + "," + ary[c]);
                        continue;
                    }
                    var _c = c + 1;
                    for (var d = _c; d < len; d++) {
                        if (cycle == 4) {
                            _count++;
                            list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d]);
                            continue;
                        }
                        var _d = d + 1;
                        for (var e = _d; e < len; e++) {
                            if (cycle == 5) {
                                _count++;
                                list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e]);
                                continue;
                            }
                            var _e = e + 1;
                            for (var f = _e; f < len; f++) {
                                if (cycle == 6) {
                                    _count++;
                                    list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f]);
                                    continue;
                                }
                                var _f = f + 1;
                                for (var g = _f; g < len; g++) {
                                    if (cycle == 7) {
                                        _count++;
                                        list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g]);
                                        continue;
                                    }
                                    var _g = g + 1;
                                    for (var h = _g; h < len; h++) {
                                        if (cycle == 8) {
                                            _count++;
                                            list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h]);
                                            continue;
                                        }
                                        var _h = h + 1;
                                        for (var y = _h; y < len; y++) {
                                            if (cycle == 9) {
                                                _count++;
                                                list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h] + "," + ary[y]);
                                                continue;
                                            }
                                            var _y = y + 1;
                                            for (var z = _y; z < len; z++) {
                                                if (cycle == 10) {
                                                    _count++;
                                                    list.push(ary[a] + "," + ary[b] + "," + ary[c] + "," + ary[d] + "," + ary[e] + "," + ary[f] + "," + ary[g] + "," + ary[h] + "," + ary[y] + "," + ary[z]);
                                                    continue;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return { list: list, count: _count };
    }
};

function forceMiddle(msg) {
    var id = msg.id || +new Date();
    var title = msg.title || "";
    var title_nav = msg.titleNav || "";
    var theadAry = msg.thead || [];
    var tbodyAry = msg.tbody || [];

    if (title) {
        $("#shell_title").html(title);
    }

    if (title_nav && title_nav != "") {
        $("#shell_top").append("<div id='title-nav'>" + title_nav + "</div>");
    }

    var mythead = ["<tr>"];
    for (var i = 0; i < theadAry.length; i++) {
        mythead.push("<th>" + theadAry[i] + "</th>");
    }
    mythead.push("</tr>");
    if (msg.eachThead) {
        mythead = [msg.eachThead];
    }

    var fonDiv = "";
    if (msg.fonDiv) {
        fonDiv = "<div id='fondiv' style='text-align:center;padding:5px 0;margin-top:2px;' class='bc'><a href='javascript:void(0);'>點擊獲取更多...</a><span id='nodataTitle' class='hiden'>無數據加載！</span></div>";
    }
    return "<div id='" + id + "'><table class='middle-table'><thead>" + mythead.join("") + "</thead><tbody>" + tbodyAry.join("") + "</tbody></table>" + fonDiv + "</div>";
}

function pageMiddle(msg, callBack) {
    var currentPage = msg.currentPage || 0;
    var totalPage = msg.totalPage || 0;
    var middle = "<div id='shell_pageControl'><div class='pager' id='data-page'>"
        + "<span class='first cursor' id='first'>首页</span>"
        + "<span class='previous cursor' id='previous'>上一页</span>"
        + "<span class='current_page'>第<b id='currentPage'>" + currentPage + "</b>页</span>"
        + "<span class='total_page'>共<b class='total' id='totalPage'>" + totalPage + "</b>页</span>"
        + "<span class='next cursor' id='next'>下一页</span>"
        + "<span class='last cursor' id='last'>尾页</span>"
        + "</div></div>";
    if (msg.obj) {
        if ($("#data-page").length == 0) {
            msg.obj.html(middle);
        }
        msg.obj.html(middle);
        //绑定分页事件
        $("#data-page span.cursor").unbind("click").click(function () {
            var page = G.searchPage($(this));
            if (page && callBack) {
                if (callBack) {
                    callBack(G.urlReplace({ url: "?" + msg.referrer, paramName: "page", val: page, pad: true }).replace("?", ""));
                }
            }
        });
    }
}
//模拟测速
function SelectBoxSet(n) {

    var data = __sysinfo.ipJoin || __sysinfo.data.ipJson;;
    for (var k = 0; k < data.length; k++) {
        ping({
            url: data[k], beforePing: function (index) {
                $("#lineching input[type='text']").eq(index).val("测速中");
            }, afterPing: function (index, time) {
                var t = "";
                if (time < 200) {
                    t = "超好";
                } else if (time < 500) {
                    t = "较好";
                } else if (time >= 2000) {
                    t = "超时";
                } else {
                    t = time + "毫秒";
                }
                $("#lineching input[type='text']").eq(index).val(t);

            }, interval: 1, idx: k
        })
    }


}

function ping(option) {
    var time, requestTime, responseTime;
    var getUrl = function (url) {    //保证url带http://
        var strReg = "^((https|http)?://){1}"
        var re = new RegExp(strReg);
        return re.test(url) ? url : "http://" + url;
    }/*
    $.ajax({
        url: getUrl(option.url) + '/netTest/?date=' + (new Date()).getTime(),  //设置一个空的ajax请求
        type: 'GET',
        dataType: 'json',
        timeout: 3000,
        beforeSend: function () {
            if (option.beforePing) option.beforePing(option.idx);
            requestTime = new Date().getTime();
        },
        complete: function (json) {
            responseTime = new Date().getTime();
            time = Math.abs(requestTime - responseTime);
            if (option.afterPing) option.afterPing(option.idx, time);
        }
    });
*/


}

function floatAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    return m = Math.pow(10, Math.max(r1, r2)), parseFloat(((arg1 * m + arg2 * m) / m).toFixed(5));
}

function floatSubtr(arg1, arg2) {
    return floatAdd(arg1, -arg2);
}

function peishuquanzhuan(category, peiNumArr, dw5zi, qz) {

    var createNumberArr = [];
    if (category == 2) {

        for (var n = 0; n < peiNumArr[0].length; n++) {
            for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
                if (qz && n == n2) { continue; }
                for (var k = 0; k < 3 + dw5zi; k++) {
                    for (var k2 = k + 1; k2 < 4 + dw5zi; k2++) {
                        var tmp = [[0, 1], [1, 0]];
                        var tmp2 = [peiNumArr[0][n], peiNumArr[1][n2]];
                        for (var q = 0; q < tmp.length; q++) {
                            var number = ['X', 'X', 'X', 'X', 'X'];
                            number[k] = tmp2[tmp[q][0]];
                            if (dw5zi == 1) number[4] = tmp2[tmp[q][1]];
                            else number[k2] = tmp2[tmp[q][1]];
                            if (createNumberArr.indexOf(number.join("")) == -1)
                                createNumberArr.push(number.join(""));
                        }
                    }
                }
            }
        }
    } else if (category == 3) {

        for (var n = 0; n < peiNumArr[0].length; n++) {
            for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
                if (qz && n == n2) { continue; }
                for (var n3 = 0; n3 < peiNumArr[2].length; n3++) {
                    if (qz && (n3 == n2 || n3 == n)) { continue; }
                    for (var k = 0; k < 2; k++) {
                        for (var k2 = k + 1; k2 < 3; k2++) {
                            for (var k3 = k2 + 1; k3 < 4; k3++) {
                                var tmp = [[0, 1, 2], [0, 2, 1], [1, 0, 2], [1, 2, 0], [2, 0, 1], [2, 1, 0]];
                                var tmp2 = [peiNumArr[0][n], peiNumArr[1][n2], peiNumArr[2][n3]];
                                for (var q = 0; q < tmp.length; q++) {
                                    var number = ['X', 'X', 'X', 'X', 'X'];
                                    number[k + dw5zi] = tmp2[tmp[q][0]];
                                    number[k2 + dw5zi] = tmp2[tmp[q][1]];
                                    if (dw5zi == 1) number[4] = tmp2[tmp[q][2]];
                                    else number[k3 + dw5zi] = tmp2[tmp[q][2]];
                                    if (createNumberArr.indexOf(number.join("")) == -1)
                                        createNumberArr.push(number.join(""));
                                }
                            }
                        }
                    }
                }
            }
        }
    } else if (category == 4) {
        for (var n = 0; n < peiNumArr[0].length; n++) {
            for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
                if (qz && n == n2) { continue; }
                for (var n3 = 0; n3 < peiNumArr[2].length; n3++) {
                    if (qz && (n3 == n2 || n3 == n)) { continue; }
                    for (var n4 = 0; n4 < peiNumArr[3].length; n4++) {
                        if (qz && (n3 == n4 || n4 == n2 || n4 == n)) { continue; }
                        for (var k = 0; k < 1; k++) {
                            for (var k2 = k + 1; k2 < 2; k2++) {
                                for (var k3 = k2 + 1; k3 < 3; k3++) {
                                    for (var k4 = k3 + 1; k4 < 4; k4++) {
                                        var tmp = [[0, 1, 2, 3], [0, 1, 3, 2], [0, 2, 1, 3], [0, 2, 3, 1], [0, 3, 2, 1], [0, 3, 1, 2],
                                        [1, 0, 2, 3], [1, 0, 3, 2], [1, 2, 0, 3], [1, 2, 3, 0], [2, 0, 1, 3], [2, 0, 3, 1], [2, 1, 0, 3], [2, 1, 3, 0]
                                            , [2, 3, 0, 1], [2, 3, 1, 0], [3, 0, 1, 2], [3, 0, 2, 1], [3, 1, 0, 2], [3, 1, 2, 0], [3, 2, 0, 1], [3, 2, 1, 0]];
                                        var tmp2 = [peiNumArr[0][n], peiNumArr[1][n2], peiNumArr[2][n3], peiNumArr[3][n4]];
                                        for (var q = 0; q < tmp.length; q++) {
                                            var number = ['', '', '', '', ''];
                                            number[k] = tmp2[tmp[q][0]];
                                            number[k2] = tmp2[tmp[q][1]];
                                            number[k3] = tmp2[tmp[q][2]];
                                            number[k4] = tmp2[tmp[q][3]];

                                            number.splice(dw5zi - 1, 0, 'X');

                                            if (createNumberArr.indexOf(number.join("")) == -1)
                                                createNumberArr.push(number.join(""));
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return createNumberArr;
}

function dwcreatenumber(category, posNumArr, numPos) {

    var createNumberArr = [];
    if (category == 2) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                var number = ['X', 'X', 'X', 'X', 'X'];
                number[numPos[0]] = posNumArr[numPos[0]][i];
                number[numPos[1]] = posNumArr[numPos[1]][n];
                if (createNumberArr.indexOf(number.join("")) == -1)
                    createNumberArr.push(number.join(""));
            }
        }
    } else if (category == 3) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
                    var number = ['X', 'X', 'X', 'X', 'X'];
                    number[numPos[0]] = posNumArr[numPos[0]][i];
                    number[numPos[1]] = posNumArr[numPos[1]][n];
                    number[numPos[2]] = posNumArr[numPos[2]][n2];
                    if (createNumberArr.indexOf(number.join("")) == -1)
                        createNumberArr.push(number.join(""));
                }
            }
        }
    } else if (category == 4) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
            for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
                for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
                    for (var n3 = 0; n3 < posNumArr[numPos[3]].length; n3++) {
                        var number = ['X', 'X', 'X', 'X', 'X'];
                        number[numPos[0]] = posNumArr[numPos[0]][i];
                        number[numPos[1]] = posNumArr[numPos[1]][n];
                        number[numPos[2]] = posNumArr[numPos[2]][n2];
                        number[numPos[3]] = posNumArr[numPos[3]][n3];
                        if (createNumberArr.indexOf(number.join("")) == -1)
                            createNumberArr.push(number.join(""));
                    }
                }
            }
        }
    }
    return createNumberArr;
}

function brother(number) {

    var tmpNumber = [];
    for (var n = 0; n < number.length; n++) {
        if (number[n] != 'X') tmpNumber.push(number[n]);
    }
    tmpNumber = tmpNumber.sort();
    var quchong = [];
    for (var n2 = 0; n2 < tmpNumber.length; n2++) {
        if (quchong.indexOf(tmpNumber[n2]) == -1) quchong.push(tmpNumber[n2]);
    }

    tmpNumber = quchong;

    var count = 0;//9810 0459
    for (var n = 1; n < tmpNumber.length; n++) {
        if (tmpNumber[n] - tmpNumber[n - 1] == 1) count++;
        else if (count > 0) break;
    }

    if ((tmpNumber.length == 2 || tmpNumber.length == 3) && (tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9)) {
        count++;
    } else if (tmpNumber.length == 4) {
        if (tmpNumber.join("") == "0189") count = 3;
        else if (count == 0 && tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9) count = 1;
        else if (tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9 && (tmpNumber[1] - tmpNumber[0] == 1 || tmpNumber[3] - tmpNumber[2] == 1)) count++;
    }


    return count + 1;

}

function chong(number) {

    number = number.replace(/X/g, "");
    var tmpNumber = {};
    for (var i = 0; i < number.length; i++) {
        if (tmpNumber[number[i]]) {
            tmpNumber[number[i]]++;
        } else {
            tmpNumber[number[i]] = 1;
        }
    }

    var count = 0;
    var ssc = 0;
    for (var key in tmpNumber) {
        if (tmpNumber[key] > count) count = tmpNumber[key];
        if (tmpNumber[key] == 2) ssc++;
    }

    if (ssc == 2) return 5;

    return count;


}

function getNumbersByCategory(category, dw5zi) {
    var numPosArr;
    if (category == 2) {
        if (dw5zi == 0) numPosArr = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 3], [2, 3]];
        else numPosArr = [[0, 4], [1, 4], [2, 4], [3, 4]];
    } else if (category == 3) {
        if (dw5zi == 0) numPosArr = [[0, 1, 2], [0, 1, 3], [0, 2, 3], [1, 2, 3]];
        else numPosArr = [[0, 1, 4], [0, 2, 4], [0, 3, 4], [1, 2, 4], [1, 3, 4], [2, 3, 4]];
    } else if (category == 4) {
        numPosArr = [[0, 1, 2, 3], [0, 1, 2, 4], [0, 1, 3, 4], [0, 2, 3, 4], [1, 2, 3, 4]];
        var index = [4, 3, 2, 1, 0];
        numPosArr = [numPosArr[index[dw5zi - 1]]];
    }
    var allNumberArr = [];
    for (var i = 0; i < numPosArr.length; i++) {
        var allPeiNumArr = [];
        var posArr = numPosArr[i];
        for (var n = 0; n < posArr.length; n++) {
            allPeiNumArr[posArr[n]] = "0123456789";
        }

        allNumberArr = allNumberArr.concat(dwcreatenumber(category, allPeiNumArr, posArr));

    }
    return allNumberArr;
}


//集合去掉重复
Array.prototype.uniquelize = function () {
    var tmp = {},
        ret = [];
    for (var i = 0, j = this.length; i < j; i++) {
        if (!tmp[this[i]]) {
            tmp[this[i]] = 1;
            ret.push(this[i]);
        }
    }

    return ret;
}

///集合取交集
Array.intersect = function () {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
            }
            else {
                obj[str]++;
                if (obj[str] == arguments.length) {
                    result.push(str);
                }
            }//end else
        }//end for j
    }//end for i
    return result;
}

//2个集合的差集 在arr不存在
Array.prototype.minus = function (arr) {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
        obj[arr[i]] = 1;
    }
    for (var j = 0; j < this.length; j++) {
        if (!obj[this[j]]) {
            obj[this[j]] = 1;
            result.push(this[j]);
        }
    }
    return result;
};

//并集
Array.union = function () {
    var arr = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
                arr.push(str);
            }
        }//end for j
    }//end for i
    return arr;
}


function gametop(gameIndex, isNumTo) {
    for (var i in __sysinfo.data.gameList) {
        if (i == gameIndex) {
            showgametop({ gameIndex: i, isNumTo: isNumTo, gameList: __sysinfo.data.gameList[i] });
        }
    }
}
function showgametop(msg) {
    if (msg.gameIndex == 1) {
        $(".game_pic #game_logo").attr("src", "../images/member/HK.png");
        $(".game_pic a").attr("href", "http://www.hkjc.com/home/chinese/index.asp");
        $("#game_name p[name='row_small']").html("每周二、四、六 <b><span id='begintime'></span>-<span id='endtime'></span></b>開盘");
    } else {
        $("#game_name p[name='row_small']").html("<b><span id='intervaltime'></span></b>一期，每天<b><span id='begintime'></span>-<span id='endtime'></span></b>銷售");
        if (msg.gameIndex == 2) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/KLC.png");
        } else if (msg.gameIndex == 3) {
            $(".game_pic #game_logo").attr("src", "../images/SSC.png");
        } else if (msg.gameIndex == 4) {
            $(".game_pic #game_logo").attr("src", "../images/PK.png");
        } else if (msg.gameIndex == 5) {
            $(".game_pic #game_logo").attr("src", "/images/Member/KS.png");
        } else if (msg.gameIndex == 6) {
            $(".game_pic #game_logo").attr("src", "/images/Member/KLB.png");
        } else if (msg.gameIndex == 7) {
            $(".game_pic #game_logo").attr("src", "/images/Member/NC.png");
        } else if (msg.gameIndex == 8) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/FT.png");
        } else if (msg.gameIndex == 10) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/GX.png");
        } else if (msg.gameIndex == 13) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/KS.png");
        } else if (msg.gameIndex == 14) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/pkjs.png");
        } else if (msg.gameIndex == 15) {
            $(".game_pic #game_logo").attr("src", "/Images/Member/SSCJS.png");
        }
    }

    var boxList = [], active;

    for (var i = 0; i < msg.gameList.length; i++) {
        active = i == 0 ? "active" : "";
        for (var n in msg.gameList[i]) {
            boxList.push("<li class='subBtn " + active + "'><a href='javascript:void(0)' data-action='" + n + "'>" + msg.gameList[i][n] + "</a></li>");

        }

    }
    $("#closedTime").html("").addClass("time_loading");
    $("#updateTime").html("...");
    $("#cqlResult").html("");
    $("#hot_Cool").html("");
    $("#numNavList").html(boxList.join(""));

    var data_action = $("#game_box_title li.active a[data-action]").attr("data-action");
    if (msg.isNumTo) {
        data_action = data_action + "&isNumTo=1";
    }
    middleBind({ data_action: data_action });
}


//数据加载（调用方法前已中断所有连接及时间轴）

var checkgamedatatime;

function gamedata(msg) {

    clearTimeout(checkgamedatatime);

    game_loading_wrap(true);
    var data_action = "member" + msg.data_action;
    var gameIndex = G.query("gameIndex", "?" + msg.data_action);
    var type = G.query("type", "?" + msg.data_action);
    var my_type = type;

    if (gameIndex == 3 && type >= 9 && type <= 18) my_type = 9;

    $("#game_box_title li").removeClass("active");
    if ($("#result2").length == 0) $("#game_box_title li a[data-action='gamedata&gameIndex=" + gameIndex + "&type=" + my_type + "']").parent("li").addClass("active");
    $("#game_big_name").html($("#menuText span").html());
    if (gameIndex != 1) {
        $(".rightBox div.left li").addClass("active");
        $(".rightBox div.right ul").addClass("active");
        $(".rightBox div.left li[name='lmResult']").css("display", "block");
        $(".rightBox div.left li[name='putResult']").removeClass("active");
        $(".rightBox div.right #putResult").removeClass("active");
    }
    $(".rightBox div.left li[name='knResult']").remove();
    $(".rightBox div.right #knResult").remove();/*
    S.request = G.ajax(data_action, function (json) {
        $("#game_small_name").html($("#game_box_title li.active a").html());
        $("#profit").html(json.win) //今天输赢
        $("#usableCreditSpan").html(json.usableCredit); //可用额
        $("#creditSpan").html(json.credit); //额度
        $("#phase1").html(json.phase[0]);
        $("#phase2").html(json.phase[1]);
        $("#intervaltime").html(json.phase[2] + "分钟");
        $("#begintime").html(json.phase[3]);
        $("#endtime").html(json.phase[4]);
        $("#newPhase").html(json.openNumList.newnumber);
        $("#fan").html(json.fan);
        var numList = json.openNumList.numList;
        var No = function () { if (gameIndex == 1) return "HK"; else if (gameIndex == 2) return "KLC"; else if (gameIndex == 3 || gameIndex == 15) return "SSC"; else if (gameIndex == 4 || gameIndex == 8 || gameIndex == 14) return "PK"; else if (gameIndex == 5) return "KS"; else if (gameIndex == 6) return "KLB"; else if (gameIndex == 7) return "NC"; else if (gameIndex == 10) return "GX"; else if (gameIndex == 13) return "KS"; };
        for (var i = 0; i < numList.length; i++) {
            numList[i] = "<i class='" + No() + "No_" + numList[i] + "'></i>";
        }
        $("#prevBall").html(numList.join(""));
        $("#NowJq").html(json.openDateList.number || "NO");
        var closeTime = json.openDateList.endTime;
        var lotteryTime = json.openDateList.lotteryTime;
        var time = closeTime == 0 && lotteryTime == 0 ? 0 : closeTime > 0 ? closeTime : lotteryTime > 0 ? lotteryTime : 0;
        var closeText = closeTime == 0 && lotteryTime == 0 || closeTime > 0 ? "封盘" : "开奖";
        $("#closeText").html(closeText);

        //最新5笔下注
        if (json.putResult) {
            var result = [], on;
            for (var i = 0; i < json.putResult.length; i++) {
                on = i % 2 == 0 ? "on" : "";
                result.push("<li class='" + on + "'>" + json.putResult[i] + "</li>");
            }
            if (result.length > 0) {
                $("#putResult").html(result.join(""));
            }
        }

        //加载对应模板
        if ($("#result2").length == 0) {
            if (json.oddsList && type < 19) {
                GameMiddle({ gameIndex: gameIndex, type: type, data: json });
            } else if (type == 19) {
                fastbet({ gameIndex: gameIndex, type: type, data: json });
            } else if (type == 20) {
                kuaixian(2);
            } else if (type == 21) {
                kuaiyi();
            } else if (type == 22) {
                txtdaoru();
            } else if (json.oddsList && type == 23) {
                fantan(json);
            }
        }
        //倒计时
        if ((closeTime == 0 && lotteryTime == 0)) {
            $("#updateTime").html("...");
            $("#closedTime").removeClass("time_loading").html("<span>0</span><span>0</span>分<span>0</span><span>0</span>秒");

            checkgamedatatime = setTimeout(function () {

                var myaction = G.urlReplace({ url: "?" + msg.data_action, paramName: "isCl", val: "1", pad: true });
                myaction = G.urlReplace({ url: myaction, paramName: "isNumto" }).replace("?", "");
                middleBind({ data_action: myaction });
            }, 10000);

            return;
        }
        var updateTime = 93, timeAry;
        S.intervalTime = setInterval(function () {
            time--;
            if (time > 0) {
                if (gameIndex == 1) {
                    settimer = G.settimer(time).replace(/:/g, '');
                } else {
                    settimer = G.settimes(time).replace(/:/g, '');
                }
                timeAry = [];
                for (var n = 0; n < settimer.length; n++) {
                    timeAry.push(settimer.substring(n, n + 1));
                }
                if (gameIndex == 1) {
                    $("#closedTime").removeClass("time_loading").html("<span>" + timeAry[0] + "</span><span>" + timeAry[1] + "</span>時<span>" + timeAry[2] + "</span><span>" + timeAry[3] + "</span>分<span>" + timeAry[4] + "</span><span>" + timeAry[5] + "</span>秒");
                } else {
                    $("#closedTime").removeClass("time_loading").html("<span>" + timeAry[0] + "</span><span>" + timeAry[1] + "</span>分<span>" + timeAry[2] + "</span><span>" + timeAry[3] + "</span>秒");
                }
            } else { //封盘或开奖时间结束
                clearInterval(S.intervalTime);
                S.loadingWrap = false;
                $("#closedTime").html("").addClass("time_loading");
                $("#updateTime").html("...");
                var isCl = "1";
                if ($("#betList").length > 0) isCl = "0";
                var myaction = G.urlReplace({ url: "?" + msg.data_action, paramName: "isCl", val: isCl, pad: true });
                myaction = G.urlReplace({ url: myaction, paramName: "isNumto" }).replace("?", "");
                middleBind({ data_action: myaction });
            }

        }, 1000);

        //addCqlResult(json);
        addFanResult(json)

            //读取最新开奖
            (function () {
                if (S.intervalOpenTime) {
                    clearInterval(S.intervalOpenTime);
                }
                var _continueNum = function () {
                    var newnumber = json.openNumList.newnumber || 0;
                    G.ajax("AutoNewNumber&gameIndex=" + gameIndex, function (json) {
                        var m = json.result;
                        if (m == "continue") {
                            S.intervalOpenTime = setTimeout(_continueNum, 5000);
                        } else if (newnumber > 0 && G.NumberSign(m) && parseInt(m) > parseInt(newnumber)) {
                            setTimeout(function () {
                                if (__sysinfo.voice == 1) {
                                    if ($("#Sound").length == 0) {
                                        $("body").append("<div id='Sound'><embed src='/images/ClewSound.swf' loop='false' autostart='false' mastersound='' width='0' hidden='true' height='0'></div>");
                                        setTimeout(function () { $("#Sound").remove(); }, 5000);
                                    }
                                }
                                S.loadingWrap = false;
                                var myaction = G.urlReplace({ url: "?" + msg.data_action, paramName: "isCl" });
                                myaction = G.urlReplace({ url: myaction, paramName: "isNumto", val: "1", pad: true }).replace("?", "");
                                middleBind({ data_action: myaction });
                            }, 2000);
                        }
                    }, function () {
                        if (S.intervalOpenTime) {
                            clearInterval(S.intervalOpenTime);
                        }
                    });
                };
                _continueNum();
            })();
    });
    */
}

function game_loading_wrap(stop) {
    if (S.loadingWrap) {
        if (stop) {
            $(".game_loading_wrap").css("display", "block");
            $("#gameBox").css("display", "none");
        } else {
            $(".game_loading_wrap").css("display", "none");
            $("#gameBox").css("display", "block");
        }
    }
}

//Game一級導航
function gameBoxTitleClick() {
    $("#game_box_title a[data-action]").unbind("click").click(function () {
        S.loadingWrap = true;
        $("#result2").remove();
        var data_action = $(this).attr("data-action");
        middleBind({ data_action: data_action });
    });
}
function gameTitleClick() {
    $("#gameTitle li").unbind("click").click(function () {
        if (!S.stop) {
            return false;
        }
        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
        $("#gameTitle li").removeClass("active");
        $(this).addClass("active");
        if ($(this).attr("data-mysort")) {
            var sort, myodds;
            var data_dow = $(this).attr("data-dow");
            var mystr = $(this).find("h3").html();
            var data_mysort = parseInt($(this).attr("data-mysort"));
            var gameIndex = $("#menuText").attr("data-index");
            if (gameIndex == 1) {
                if (data_mysort == 154 || data_mysort >= 676 && data_mysort <= 679) {
                    myodds = $(this).find("h4").html();
                    if (!G.DecimalSign(myodds)) {
                        myodds = "-";
                        $("#gameBox li span.in a.radioSim").addClass("radiodsable");
                    } else {
                        $("#gameBox li span.in a.radioSim").removeClass("radiodsable");
                    }
                    $("#gameBox li span.p a.red").html(myodds);
                }
            } else if (gameIndex == 2) {
                if (data_mysort == 323 || data_mysort == 324 || data_mysort == 325 || data_mysort == 326 || data_mysort == 327 || data_mysort == 328 || data_mysort == 329) {
                    myodds = $(this).find("h4").html();
                    if (!G.DecimalSign(myodds)) {
                        $("#gameBox li span.in a.radioSim").addClass("radiodsable");
                    } else {
                        $("#gameBox li span.in a.radioSim").removeClass("radiodsable");
                    }
                    $("#gameBox legend").html(mystr);
                }
            } else if (gameIndex == 13) {
                if (data_mysort == -1) {
                    $("#gameBox li.auto").addClass("hiden");
                    $("#gameBox li." + data_dow).removeClass("hiden");
                    $("#clearBtn").click();
                }
            }
        }
        var data_action = $(this).attr("data-action"); //參數判斷是否重新加載數據
        if (data_action) {
            S.loadingWrap = true;
            middleBind({ data_action: data_action });
        }
    });
}

//赔率刷新加载
function loadOdds(oddsList) {
    var gameBox = $("#gameBox");
    var gameIndex = $("#menuText").attr("index");
    var oddsEvent, inputEvent;
    for (var i in oddsList) {
        if (gameIndex == 1 && i == 154) {
            //hxOddsSum({ odds: oddsList[i], duplex: 6, upodds: __info.autoOdds[0] });
        } else if (gameIndex == 1 && (parseInt(i) >= 684 && parseInt(i) <= 732 || parseInt(i) >= 610 && parseInt(i) <= 675 || parseInt(i) >= 1187 && parseInt(i) <= 1198 || parseInt(i) >= 746 && parseInt(i) <= 1137)) {
            //hxOddsSum({ odds: oddsList[i], duplex: 7, upodds: __info.autoOdds[1] });
        } else if (gameIndex == 2 && parseInt(i) >= 323 && parseInt(i) <= 329) {

        } else {
            oddsEvent = gameBox.find("li[data-sort='" + i + "'] span.p a.oddsEvent");
            inputEvent = gameBox.find("li[data-sort='" + i + "'] span.in input[type='text']");
            if (G.DecimalSign(oddsList[i])) {
                inputEvent.attr("disabled", "");
                if (oddsEvent.html() != oddsList[i])
                    oddsEvent.html(oddsList[i]);
            } else {
                inputEvent.attr("disabled", "disabled").val("");
                oddsEvent.html("-");
            }
        }
    }
}

//兩面長龍
function clsort(clList) {
    var key, val, on, lmResult = [], vak;
    if (clList) {
        clList.sort(function (a, b) {
            var _a = a.split(":")[1], _b = b.split(":")[1];
            return parseInt(_b) - parseInt(_a);
        });
        for (var i = 0; i < clList.length; i++) {
            key = clList[i].split(":");
            val = key[0].split(" ");
            on = i % 2 != 0 ? "on" : "";
            vak = val[1] ? " - <b class='red'> " + val[1] + "</b>" : "";
            lmResult.push("<li class='" + on + "'><span>" + key[1] + "期</span>" + val[0] + vak + "</b></li>");
        }
        if (lmResult.length > 0) {
            $("#lmResult").html(lmResult.join(""));
        } else {
            $("#lmResult").html("");
        }
    }
}
function addFanResult(msg) {

    if (!msg.trendContent) {
        $("#cqlResult").html("");
        return;
    }

    var dib, s;

    var result = "<div class='trend_con'><ul class='base-clear'>";
    for (var i = 0; i < 1; i++) {
        s = i == 0 ? "active" : "";
        dib = [];
        if (msg.trendContent[i]) {
            for (var k = 0; k < msg.trendContent[i].length; k++) {
                dib.push("<span class='dib'>");
                dib.push("<em>" + msg.trendContent[i][k] + "</em>");
                for (var n = k + 1; n < msg.trendContent[i].length; n++) {
                    if (msg.trendContent[0][n] && msg.trendContent[i][n] % 2 == msg.trendContent[i][k] % 2) {
                        dib.push("<em>" + msg.trendContent[i][n] + "</em>");
                        k++;
                    } else {
                        break;
                    }
                }
                dib.push("</span>,");
            }
        }
        var jon = dib.join("").split(",");
        dib = [];
        for (var q = 0; q < 33; q++) {
            if (jon[q] && jon[q] != "")
                dib.unshift(jon[q]);
        }
        result += "<li class='tab_item " + s + " dib-wrap'>" + dib.join("") + "</li>";
    }
    result += "</ul></div>";
    $("#cqlResult").html(result);

}


function addCqlResult(msg) {
    if (msg.trendLi) {
        var dib, s;
        var count = msg.trendLi.length;
        var result = "<div class='trend_title'><ul class='base-clear'>";
        for (var i = 0; i < count; i++) {
            s = i == 0 ? "active" : "";
            result += "<li index='" + i + "' class='tab_btn " + s + "'><a href='javascript:void(0)'>" + msg.trendLi[i] + "</a></li>";
        }
        result += "</ul></div>";

        result += "<div class='trend_con'><ul class='base-clear'>";
        for (var i = 0; i < count; i++) {
            s = i == 0 ? "active" : "";
            dib = [];
            if (msg.trendContent[i]) {
                for (var k = 0; k < msg.trendContent[i].length; k++) {
                    dib.push("<span class='dib'>");
                    dib.push("<em>" + msg.trendContent[i][k] + "</em>");
                    for (var n = k + 1; n < msg.trendContent[i].length; n++) {
                        if (msg.trendContent[0][n] && msg.trendContent[i][n] == msg.trendContent[i][k]) {
                            dib.push("<em>" + msg.trendContent[i][n] + "</em>");
                            k++;
                        } else {
                            break;
                        }
                    }
                    dib.push("</span>,");
                }
            }
            var jon = dib.join("").split(",");
            dib = [];
            for (var q = 0; q < 25; q++) {
                if (jon[q] && jon[q] != "")
                    dib.unshift(jon[q]);
            }
            result += "<li class='tab_item " + s + " dib-wrap'>" + dib.join("") + "</li>";
        }
        result += "</ul></div>";
        $("#cqlResult").html(result);
        $("#cqlResult div.trend_title li.tab_btn").unbind("click").click(function () {
            $("#cqlResult div.trend_title li.tab_btn").removeClass("active");
            var index = $(this).addClass("active").attr("index");
            $("#cqlResult div.trend_con li.tab_item").removeClass("active");
            $("#cqlResult div.trend_con li:eq(" + index + ")").addClass("active");
        });
    }
}

function bindGameFun(vue) {  
    var gameIndex = $("#menuText").attr("data-index");
    var obj = $("#gameBox");
    
    obj.find("input[type='text']").keyup(function () {
        G.clearNoNum($(this));
        $(this).addClass("check");
    });
    obj.find("input[type='text']").unbind('focus').focus(function () {
        console.log('check')
        if (!$(this).hasClass("check")) {
            $(this).val($("#tool_ys_input").val());
            $(this).addClass("check");
        } else {
            $(this).val("");
            $(this).removeClass("check");
        }
    });
    obj.find("li span.p a.oddsEvent").unbind("click").click(function () {
        var n1 = $(this).parents("li").attr("data-title");
        var n2 = $(this).parents("li").find("input[type='text']").attr("data-number");
        var sort = $(this).parents("li").attr("data-sort");
        var odds = $(this).html();

        myWarp({ gameIndex: gameIndex, odds: odds, n1: n1, n2: n2, sort: sort, obj: $(this) });
    });
    //勾选項
    obj.find("li span.in a").unbind("click").click(function () {
        var myclass = $(this).attr("class");
        var mymax = parseInt($("#gameTitle li.active").attr("data-max"));
        if (myclass.indexOf("radiodsable") == -1) {
            if (myclass.indexOf("radioPoint") == -1) {
                $(this).addClass("radioPoint");
                enachRadioPoint($(this), mymax);
            } else {
                $(this).removeClass("radioPoint");
            }
        }
    });

    $("#clearBtn").unbind("click").click(function () {
        obj.find("input[type='text']").val("").removeClass("check");
        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
        obj.find("a[class='kxhotbtn']").each(function () {
            $(this).attr("class", "kxbtn");
        });
        $("#tool_ys_input").val("");
        $("#ipdw_1").val("");
        $("#ipdw_2").val("");
    });
    var data_type = parseInt(G.query("type", "?" + $("#game_box_title li.active a").attr("data-action")));

    $('#tool_ys_input').unbind("keyup").keyup(function(event){
        if(event.keyCode ==13){
            $("#gameSubmit").click()
        }
    });
    $("#gameSubmit").unbind("click").click(function () {
        if (gameIndex == 1 && (data_type == 4 || data_type == 16 || data_type == 22 || data_type == 29)) {
            gameHxSubmit(data_type);
        } else if ((gameIndex == 2 || gameIndex == 7) && data_type == 12) {
            gameHxSubmit(data_type);
        } else {
            gameSubmit(vue);
        }
    });
    obj.find("input[type='text']").keydown(function (e) {
        var curKey = e.which;
        if (curKey == 13) {
            $("#gameSubmit").click();
            return false;
        }
    });

    obj.find("div[class='dsdx'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        var check;
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
            check = false;
        }
        else {
            $(this).attr("class", "kxhotbtn");
            check = true;
        }

        selectDSDX(obj, $(this).attr("data-index"));


    });

    obj.find("table[class='t_dw'] a").unbind("click").click(function () {
        var classAttr = $(this).attr("class");
        if (classAttr == "kxhotbtn") {
            $(this).attr("class", "kxbtn");
        }
        else {
            $(this).attr("class", "kxhotbtn");
        }
        selectDW(obj, this);

    });
    obj.find("table[class='t_dw'] input").keyup(function () {
        selectDW(obj, $(this));
    });

    obj.find("div[class='triangle-topleft']").unbind("click").click(function () {
        var box = $(this).parents("div.game_box").first();
        var inputs = box.find("li input[type='text']");
        var hasUnchecked = false;
        inputs.each(function () {
            if (!$(this).hasClass("check")) {
                hasUnchecked = true;
            }
        });
        inputs.each(function () {
            if (hasUnchecked) {
                $(this).val($("#tool_ys_input").val()).addClass("check");
            } else {
                $(this).val("").removeClass("check");
            }
        });
    });

    obj.find("div[class='triangle-right']").unbind("click").click(function () {
        var sort = $(this).attr("data-index");
        var input = obj.find("li[data-sort='" + sort + "'] input[type='text']");
        if (!input.hasClass("check")) {
            input.val($("#tool_ys_input").val()).addClass("check");
        } else {
            input.val("").removeClass("check");
        }
    });


    //快捷下注金额
    $("#tool_ys_wrap input[type='text']").focus(function () {
        $(this).val("");
    });
    $("#tool_ys_wrap input[type='text']").keyup(function () {
        G.clearNoNum($(this));
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        /*if ($(this).attr("id") == "tool_ys_input") {
        $("#gameBox input.check").val($(this).val()); //改变下注金额盘
        }*/
    });
    $("#tool_ys_wrap span a").unbind("click").click(function () {
        var val = $(this).html();
        var mycheck = $("#gameBox input.check");
        $("#tool_ys_input").val(val);
        mycheck.each(function () {
            // if ($(this).val() == "") {
                $(this).val(val);
            // }
        });
    });
    $("#tool_ys_wrap em b").unbind("click").click(function () {
        var ary = [];
        $("#tool_ys_wrap span a").each(function (i) {
            ary[i] = $(this).html();
        });
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            $(this).val(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "block");
    });
    $("#tool_ys_wrap em strong input[type='button']").unbind("click").click(function () {

        var ary = [];
        $("#tool_ys_wrap em strong input[type='text']").each(function (i) {
            ary[i] = $(this).val();
        });
        $("#tool_ys_wrap span a").each(function (i) {
            $(this).html(ary[i]);
        });
        $("#tool_ys_wrap em strong").css("display", "none");
    });

        
}

function selectDSDX(obj, dataIndex) {

    var dataAction = $("#numNavList li.active a").attr("data-action");
    var gameIndex = 3;//G.query("gameIndex", "?" + dataAction);

    var dsdx;
    var title;
    if (gameIndex == 3) {
        dsdx = [[1, 3, 5, 7, 9], [0, 2, 4, 6, 8], [5, 6, 7, 8, 9], [0, 1, 2, 3, 4]];
        title = ["第一球", "第二球", "第三球", "第四球", "第五球"];
    } else {
        dsdx = [[1, 3, 5, 7, 9], [2, 4, 6, 8, 10], [6, 7, 8, 9, 10], [1, 2, 3, 4, 5]];
        title = ["冠军", "亚军", "第三名", "第四名", "第五名", "第六名", "第七名", "第八名", "第九名", "第十名"];
    }

    var sortArr = [];

    $(".dsdx").find("a[data-index='" + dataIndex + "']").each(function () {

        var index = -1;
        if ($(this).attr("class") == "kxhotbtn") {
            if ($(this).html() == "单") index = 0;
            else if ($(this).html() == "双") index = 1;
            else if ($(this).html() == "大") index = 2;
            else if ($(this).html() == "小") index = 3;

            if (index >= 0) {
                for (var n = 0; n < dsdx[index].length; n++) {
                    sortArr.push(dsdx[index][n]);
                }
            }
        }
    });

    var sortStr = "," + sortArr.join(",") + ",";
    obj.find("li[data-title='" + title[dataIndex] + "']").each(function () {
        var name = $(this).attr("data-name");
        if (sortStr.indexOf("," + name + ",") != -1) {
            if (!$(this).find("input").hasClass("check")) {
                $(this).find("input").addClass("check");
                if ($(this).find("input").val() == "") $(this).find("input").val($("#tool_ys_input").val());
            }
        } else {
            $(this).find("input").removeClass("check").val("");
        }

    });




}

function selectDW(obj, t) {

    obj.find("input[type='text']").removeClass("check");

    var one = [], two = [];
    $("#fix_1").find("a[class='kxhotbtn']").each(function () {
        one.push(parseInt($(this).attr("name")))

    });
    $("#fix_2").find("a[class='kxhotbtn']").each(function () {
        two.push(parseInt($(this).attr("name")))
    });

    var dsdx = [[1, 3, 5, 7, 9], [0, 2, 4, 6, 8], [5, 6, 7, 8, 9], [0, 1, 2, 3, 4]];
    var sortArr = [];
    for (var i = 0; i < one.length; i++) {
        for (var k = 0; k < two.length; k++) {
            if (one[i] <= 9 && two[k] <= 9) {
                sortArr.push(one[i] * 10 + two[k]);
            } else if (one[i] <= 9 && two[k] > 9) {
                for (var j = 0; j < dsdx[two[k] - 10].length; j++) {
                    sortArr.push(one[i] * 10 + dsdx[two[k] - 10][j]);
                }


            } else if (one[i] > 9 && two[k] <= 9) {
                for (var j = 0; j < dsdx[one[i] - 10].length; j++) {
                    sortArr.push(dsdx[one[i] - 10][j] * 10 + two[k]);
                }
            } else {
                for (var j = 0; j < dsdx[one[i] - 10].length; j++) {
                    for (var p = 0; p < dsdx[two[k] - 10].length; p++) {
                        sortArr.push(dsdx[one[i] - 10][j] * 10 + dsdx[two[k] - 10][p]);
                    }
                }
            }
        }
    }

    //合分
    var hefen = [
        [0, 19, 28, 37, 46, 55, 64, 73, 82, 91],
        [1, 10, 29, 38, 47, 56, 65, 74, 83, 92],
        [2, 11, 20, 39, 48, 57, 66, 75, 84, 93],
        [3, 12, 21, 30, 49, 58, 67, 76, 85, 94],
        [4, 22, 31, 13, 40, 59, 68, 77, 86, 95],
        [5, 14, 41, 23, 32, 50, 69, 78, 87, 96],
        [6, 15, 51, 24, 42, 33, 60, 79, 88, 97],
        [7, 16, 61, 25, 52, 34, 43, 70, 89, 98],
        [8, 17, 71, 26, 62, 35, 53, 44, 80, 99],
        [9, 18, 81, 27, 72, 36, 63, 45, 54, 90]
    ];


    $("#fn-hf").find("a[class='kxhotbtn']").each(function () {
        var name = parseInt($(this).attr("name"));
        if (name >= 0 && name <= 9) {
            for (var i = 0; i < hefen[name].length; i++) {
                sortArr.push(hefen[name][i]);
            }
        } else {
            for (var i = 0; i < dsdx[name - 10].length; i++) {
                for (var k = 0; k < hefen[i].length; k++) {
                    sortArr.push(hefen[dsdx[name - 10][i]][k]);
                }

            }
        }
    });

    //输入定位
    var ipdw_1 = $("#ipdw_1").val();
    var ipdw_2 = $("#ipdw_2").val();
    for (var i = 0; i < ipdw_1.length; i++) {
        for (var k = 0; k < ipdw_2.length; k++) {
            if (parseInt(ipdw_1[i]) >= 0 && parseInt(ipdw_2[k]) >= 0) {
                sortArr.push(parseInt(ipdw_1[i]) * 10 + parseInt(ipdw_2[k]))
            }
        }
    }

    var sortStr = "," + sortArr.join(",") + ",";

    obj.find("li").each(function () {
        var number = ($(this).attr("data-name") || "").replace(/[^0-9]/g, "");
        if (number.length >= 2) {
            number = number.substr(number.length - 2);
        }
        if (sortStr.indexOf(("," + parseInt(number) + ",")) != -1) {
            if (!$(this).find("input").hasClass("check")) {
                $(this).find("input").addClass("check");
                if ($(this).find("input").val() == "") $(this).find("input").val($("#tool_ys_input").val());
            }
        } else {
            $(this).find("input").removeClass("check").val("");
        }
    });


}

function enachRadioPoint(myobj, max) {
    var count = 0;
    $("#gameBox li a.radioPoint").each(function () {
        count++;
    });
    if (count > max) {
        myobj.removeClass("radioPoint");
        G.alert({ content: "组合最高可选" + max + "个号码！", ok: function () { return true; } });
    }
}
function myWarp(msg) {

    var maxPayout = "123";
    var odds = parseFloat(msg.odds);
    var sort = msg.sort;
    var title = msg.n1 + "【" + msg.n2 + "】";
    var warp = "<div class='myLayerBox' id='myWarp' data-sort='" + sort + "'>";
    warp += "<p>赔率：<em name='odds_pl' id='dzje'>" + odds + "</em>下注金额：<input name='uPI_M' id='xzjeInput' class='input onlyNum' type='text' maxlength='5'></p>";
    warp += "<p>可赢金额：<em name='valueOdds' id='valueOdds' class='blue'>0</em></p>";
    //warp += "<p>最高派彩：<i>" + maxPayout + "</i></p>";
    warp += "</div>";
    if (G.DecimalSign(odds)) {
        var content = warp, _submit, data_stop = true;
        G.alert({
            content: warp, title: title, obj: msg.obj,
            initialize: function () {
                $("#myWarp input[name='uPI_M']").focus();
                $("#myWarp input[name='uPI_M']").keyup(function () {
                    $(this).val($(this).val().replace(/[^0-9]/g, ''));
                    $("#myWarp em[name='valueOdds']").html(odds * parseInt($(this).val()));

                });
            },
            ok: function () {
                var objM = $("#myWarp input[name='uPI_M']:enabled");

                if (objM.val() == "") {
                    G.myTips({ content: "下注金额不能为空!", obj: objM, myclick: true });
                    objM.focus();
                    return false;
                } else if (!G.NumberSign(objM.val()) || parseInt(objM.val()) < 1) {
                    G.myTips({ content: "下注金额不能小于单注最小下注额度：1", obj: objM, myclick: true });
                    objM.focus();
                    return false;
                } else if (data_stop) {
                    let betMoney = document.getElementById("xzjeInput").value;
                    data_stop = false;
                    var opNum = $("#NowJq").html();
                    var type = 1;
                    var data = [sort + ":" + objM.val()];
                    objM.val("").attr("disabled", "disabled");
                    var data_action = $("#game_box_title li.active a").attr("data-action");
                    var betType = G.query("type", "?" + data_action);
                    if (betType == 2) betType = 1;
                    else betType = 2;

                    setTimeout(() => {
                        if ($(".subBtn.active").find("a").html() == "一字定" || $(".subBtn.active").find("a").html() == "二字定") {
                            let data = {};
                            data.access_token = window.sessionStorage.getItem("login").split("&")[0];
                            data.uid = window.sessionStorage.getItem("login").split("&")[1];
                            data.game_code = window.sessionStorage.getItem("code");
                            if ($(".subBtn.active").find("a").html() == "一字定") {
                                data.play_code = "D1W";
                            } else {
                                data.play_code = "D2W";
                            }
                            data.key = (new Date()).valueOf();
                            data.play_type = "zhixuan";
                            data.bet_money = betMoney;
                            data.total_money = 1 * betMoney;
                            data.bet_num = "1";
                            data.bet_str = msg.n2 + ':' + betMoney;
                            data.bet_log = "游戏日志";
                            data.bet_qihao = window.sessionStorage.getItem("qiNum");

                            getData.default.postAxiosMethod("bet2", data, res => {
                                container()
                                let isPlayer = sessionStorage.getItem('Voice')
                                if(isPlayer == 1){
                                    document.getElementById('bgm').play()
                                }
                                $('.kxhotbtn').removeClass('kxhotbtn').addClass('kxbtn')
                            });
                            $("#tool_ys_input").val("");
                        }
                    }, 1000)


                    //      dataSubmit({ gameIndex: msg.gameIndex, betType: betType, number: opNum, sortAry: data.join(",") }, false);
                    return true;
                }
            },
            cancel: function () {
                
            },
        });
    }
}
function gameHxSubmit(data_type) {
    var data_min = parseInt($("#gameTitle li.active").attr("data-min"));
    var data_max = parseInt($("#gameTitle li.active").attr("data-max"));
    var sort = $("#gameTitle li.active").attr("data-mysort");
    var dataAry = [], dataName = [];
    var cycle;
    if (data_type == 4) {
        cycle = data_max;
        var a, b, index;
        var odds = $("#gameTitle li.active h4").html();
        $("#gameBox li span.in a.radioPoint").each(function () {
            dataName.push($(this).parents("li").attr("data-name"));
            index = parseInt($(this).parents("li").attr("data-sort"));
            index % 2 == 0 ? a = true : b = true;
        });

        if ((!a || !b) && dataName.length == 6) {
            G.alert({ content: "6肖勾选排列不允許 “全单” 或 “全双” 组合！", ok: function () { return true; } });
            return false;
        }
        if (dataName.length == data_max) {
            var n1 = $("#gameBox legend").html();
            var money = $("#tool_ys_input").val();
            dataAry.push(sort);
            dataAry.push(n1);
            dataAry.push(dataName);
            dataAry.push(odds);
        }
    } else if (data_type == 16 || data_type == 22 || data_type == 29 || data_type == 12) {
        cycle = data_min;
        var odds = $("#gameTitle li.active h4").html();
        $("#gameBox li span.in a.radioPoint").each(function () {
            dataName.push($(this).parents("li").attr("data-name"));
        });

        dataName.sort(function (a, b) {
            var _a = a, _b = b;
            return parseInt(_a) - parseInt(_b);
        });

        if (dataName.length >= data_min && dataName.length <= data_max) {
            var n1 = $("#gameBox legend").html();
            var money = $("#tool_ys_input").val();
            dataAry.push(sort);
            dataAry.push(n1);
            dataAry.push(dataName);
            dataAry.push(odds);
        } else {
            G.alert({ content: "组合最高可选 " + data_min + "~" + data_max + " 个号码", ok: function () { return true; } });
            return false;
        }
    }
    if (dataAry && dataAry.length > 0) {
        var data_stop = true;
        var DuplexObj = G.DuplexSum(cycle, dataAry[2]);
        var orderWrap = "<div class='lmSubmitWrap' id='lmSubmitWrap'>";
        orderWrap += "<div class='lsw_top'><p>下注号码明细</p><p class='myNos'>" + dataAry[2].join("、") + "</p></div>";
        orderWrap += "<div id='wtWrapLm'></div>";
        orderWrap += "<div>您共选择了<span>" + dataAry[2].length + "</span>个号码 “復式” 共分为<span>" + DuplexObj.count + "</span>组</div>";
        orderWrap += "<div><em>" + dataAry[1] + " </em>";
        if (dataAry[3]) {
            orderWrap += "@<strong id='lmPl'>" + dataAry[3] + "</strong> ";
        }
        orderWrap += "单注金额：<input id='odds_lm_pl' class='input onlyNum' type='text' maxlength='7'></div>";
        orderWrap += "<div>总金额：<span id='sumCount'>0</span></div>";
        orderWrap += "</div>";
        /*G.alert({
            content: orderWrap, title: "确认下单",
            initialize: function () {
                $("#lmSubmitWrap #odds_lm_pl").focus();
                $("#lmSubmitWrap #odds_lm_pl").keyup(function () {
                    $(this).val($(this).val().replace(/[^0-9]/g, ''));
                    var sumCount = parseInt($(this).val()) * parseInt(DuplexObj.count) || 0;
                    $("#sumCount").html(sumCount);
                });
            },
            ok: function () {
                console.log("打印2057");
                if (data_stop) {
                    data_stop = false;
                    var objM = $("#lmSubmitWrap #odds_lm_pl:enabled");
                    if (objM.val() == "") {
                        G.myTips({ content: "下注金额不能为空!", obj: objM, myclick: true });
                        objM.focus();
                        return false;
                    } else if (!G.NumberSign(objM.val()) || parseInt(objM.val()) < 1) {
                        G.myTips({ content: "下注金额不能小于单注最小下注额度：1", obj: objM, myclick: true });
                        objM.focus();
                        return false;
                    } else {
                        var gameIndex = $("#menuText").attr("data-index");
                        var opNum = $("#NowJq").html();
                        var mydata = [];
                        var myCursor = encodeURIComponent(dataAry[2].join("、"));
                        for (var i = 0; i < DuplexObj.list.length; i++) {
                            mydata.push(DuplexObj.list[i] + ":" + objM.val());
                        }
                        $("#gameBox li span.in a.radioSim").removeClass("radioPoint");
                        objM.val("").attr("disabled", "disabled");
                        dataSubmit({ sort: dataAry[0], gameIndex: gameIndex, number: opNum, myCursor: myCursor, sortAry: mydata.join("|") }, "DownEntryLm");
                        return true;
                    }
                }
            },
            cancel: function () { }
        });
        */
    }
}

const submitData = (bet, total_money, vue) => {
    let str = "";
    let newArr = bet;
    str = newArr.join(',')
    let data = {};
    data.access_token = window.sessionStorage.getItem("login").split("&")[0];
    data.uid = window.sessionStorage.getItem("login").split("&")[1];
    data.game_code = window.sessionStorage.getItem("code");
    if ($(".subBtn.active").find("a").html() == "一字定") {
        data.play_code = "D1W";
    } else {
        data.play_code = "D2W";
    }
    data.key = (new Date()).valueOf();
    data.play_type = "zhixuan";
    // data.bet_money = bet[0].split(":")[1];
    data.total_money = total_money;
    data.bet_num = bet.length;
    data.bet_str = str;
    data.bet_log = "游戏日志";
    data.bet_qihao = window.sessionStorage.getItem("qiNum");
    console.log(data)
    getData.default.postAxiosMethod("bet2", data, res => {
        container()
        let isPlayer = sessionStorage.getItem('Voice')
        if(isPlayer == 1){
            document.getElementById('bgm').play()
        }
        $('.kxhotbtn').removeClass('kxhotbtn').addClass('kxbtn')
        vue.$emit("yzdData", 2);
        if(data.play_code == "D1W"){
            setTimeout(()=>{
                vue.getD1WOdds()
            },2000)
            
        }else{
            setTimeout(()=>{
                vue.getD2WOdds()
            },2000)
        }
    });
    $("#tool_ys_input").val("");
    $("#tool_hm_input").val("");
    $("#spanPeilv").html("");
    $("#spankxje").html("");
    $("#mymask").remove();
    $(".input.onlyNum.orderInput").each((index, item) => {
        item.className = "input onlyNum orderInput";
        item.value = "";
    })
    $("#myWarpr_alert").css('display', 'none');
}


function gameSubmit(vue) {
    var obj = $("#gameBox");
    var odds, money, n1, n2, sort, dataAry = [];
    var data_type = $("#game_box_title li.active").attr("data-type");

    var data_action = $("#game_box_title li.active a").attr("data-action");
    var type = G.query("type", "?" + data_action);

    var data_number = $("#NowJq").html();
    var gameIndexStr = $("#menuText").find("span").html();
    $("#gameSubmit").focus();
    //番摊
    if (type == 23) {
        obj.find("td").each(function () {
            if ($(this).attr("data-sort") && G.DecimalSign($(this).find("input[type='text']").val()) && G.DecimalSign($(this).find("span.odds").html())) {
                sort = $(this).attr("data-sort");
                n1 = $(this).attr("data-title");
                n2 = $(this).attr("data-name");
                odds = $(this).find("span.odds").html();
                money = $(this).find("input[type='text']").val();
                dataAry.push(sort + ":" + n1 + ":" + n2 + ":" + odds + ":" + money + ":" + gameIndexStr + ":" + data_number);
            }
        });
    } else {
        obj.find("li").each(function () {
            if ($(this).attr("data-sort") && G.DecimalSign($(this).find("span.in input[type='text']").val()) && G.DecimalSign($(this).find("span.p a.oddsEvent").html())) {
            // if ($(this).attr("data-sort") && G.DecimalSign($(this).find("span.in input[type='text']").val())) {
                sort = $(this).attr("data-sort");
                n1 = $(this).attr("data-title");
                n2 = $(this).attr("data-name");
                odds = $(this).find("span.p a.oddsEvent").html();
                money = $(this).find("span.in input[type='text']").val();
                dataAry.push(sort + ":" + n1 + ":" + n2 + ":" + odds + ":" + money + ":" + gameIndexStr + ":" + data_number);
            }
        });
    }
    if (dataAry && dataAry.length > 0) {
        dataAry.sort(function (a, b) {
            var _a = a.split(":")[0], _b = b.split(":")[0];
            return parseInt(_a) - parseInt(_b);
        });
        var k, count = [0, 0];
        var orderWrap = "";
        orderWrap += "<table class='order' style='width:100%'><thead><tr><th width='150'>注单明细</th><th width='120'>赔率</th><th width='80'>下注金额</th><th width='60'>操作</th><th width='60' class='cursor'>打印</th></tr></thead>";
        orderWrap += "<tbody>";
        for (var i = 0; i < dataAry.length; i++) {
            k = dataAry[i].split(":");
            orderWrap += "<tr data-sort='" + k[0] + "' data-ary='" + dataAry[i] + "'>";
            orderWrap += "<td width='150'>" + k[1] + "【" + k[2] + "】</td>";
            orderWrap += "<td width='120'><div class='plShow'>" + k[3] + "</div></td>";
            orderWrap += "<td width='80'><input class='input onlyNum orderLayerInput' value='" + k[4] + "' type='text'></td>";
            orderWrap += "<td width='60'><a class='deleteOrder deleteIcon' mysort='" + k[0] + "' title='删除' href='javascript:void(0)'></a></td>";
            orderWrap += "<td width='60'><input type='checkbox' name='print' /></td>";
            orderWrap += "</tr>";
            count[0]++;
            count[1] += parseFloat(k[4]);
        }
        orderWrap += "</tbody>";
        orderWrap += "<tfoot class='zjWrap'><tr><th colspan='5'>";
        orderWrap += "总注：<span id='zj'>" + count[0] + "</span> 笔&nbsp;&nbsp;&nbsp;&nbsp;合计金额：<span id='zjm' class='blue'>" + count[1] + "</span>";
        orderWrap += "</th></tr></tfoot>";
        orderWrap += "</table>";
        var content = G.overflowDiv({ id: "orderWrap", content: orderWrap });
        var data_stop = true;
        G.alert({
            content: content, title: "确认下单", width: 450,
            initialize: function () {
                var _myeach = function (stop) {
                    var mycount = [0, 0];
                    $("#orderWrap input[type='text']").each(function () {
                        if (G.DecimalSign($(this).val())) {
                            mycount[0]++;
                            mycount[1] += parseFloat($(this).val());
                        }
                    });
                    if (mycount[0] == 0 && stop) {
                        $("#myWarpr_alert").remove();
                        $("#mymask").remove();
                        return false;
                    } else {
                        $("#zj").html(mycount[0]);
                        $("#zjm").html(mycount[1]);
                    }
                };

                $("#orderWrap thead th.cursor").unbind("click").click(function () {
                    if (!$(this).attr("print")) {
                        $("#orderWrap tbody tr input[name='print']").attr("checked", "checked");
                        $(this).attr("print", "1");
                    } else {
                        $("#orderWrap tbody tr input[name='print']").attr("checked", false);
                        $(this).removeAttr("print");
                    }
                });

                $("#orderWrap input[type='text']").keyup(function () {
                    //$(this).val($(this).val().replace(/[^0-9]/g, ''));
                    G.clearNoNum($(this));
                    _myeach(false);
                });
                $("#orderWrap a.deleteOrder").unbind("click").click(function () {
                    $(this).parents("tr[data-sort='" + $(this).attr("mysort") + "']").remove();
                    _myeach(true);
                });
            },
            ok: function () {

                var dataAry = [];
                var printAry = [];
                var objM;
                $("#orderWrap tbody tr").each(function (index) {
                    if ($(this).attr("data-sort")) {
                        setTimeout(() => {
                            objM = $(this).find("input[type='text']:enabled");

                            if (objM.val() == "") {
                                dataAry = [];
                                G.myTips({ content: "下注金额不能为空!", obj: objM, myclick: true });
                                objM.focus();
                                return false;
                            } else if (!G.DecimalSign(objM.val()) || parseFloat(objM.val()) <= 0) {
                                dataAry = [];
                                G.myTips({ content: "下注金额不能小于单注最小下注额度：1", obj: objM, myclick: true });
                                objM.focus();
                                return false;

                            } else {
                                let arr = []
                                $("input.onlyNum").each(function(i, ele){
                                    if($(ele).val() != ''){
                                        arr.push(ele)
                                    }
                                })
                                dataAry.push($(arr[index]).attr("data-number") + ":" + objM.val());
                                if ($(this).find("input[name='print']").attr("checked")) {
                                    printAry.push($(this).attr("data-ary"));
                                }
                            }
                        }, 0)
                    }
                });
                
                setTimeout(() => {
                    if (dataAry.length > 0 && data_stop) {
                        dataAry.sort(function (a, b) {
                            var _a = a.split(":")[1], _b = b.split(":")[1];
                            return parseInt(_b) - parseInt(_a);
                        });
                        $("#orderWrap tbody tr input[type='text']").val("").attr("disabled", "disabled");
                        let total_money = 0;
                        dataAry.forEach(item => {
                            total_money += (item.split(":")[1] * 1)
                        })
                        console.log(dataAry)
                        submitData(dataAry, total_money, vue);                        
                        return true;
                    }
                }, 0)
                return true;
            },
            cancel: function () { }
        });
    }
}
function dataSubmit(data, myurl, objthis, printAry) {

    $("#gameBox input[type='text']").removeClass("check").val("");
    $("#gameBox a[class='kxhotbtn']").each(function () {
        $(this).attr("class", "kxbtn");
    });
    $("#ipdw_1").val("");
    $("#ipdw_2").val("");

    var url = myurl || "DownEntry";
    var mydata = [];
    for (var i in data) {
        mydata.push(i + "=" + data[i]);
    }
    var data_action = [url, mydata.join("&")];
    G.mask();
    G.ajax(data_action.join("&"), function (json) {

        if (json.result != 1) {
            G.maskClose();
            G.alert({ content: json.result, ok: function () { return true; } });
            return;
        }

        $("#txtnumbers").html("");
        $("#kxnumbers").html("");


        G.maskClose();
        lastBetData(json);
        newGameData(json, printAry);
    }, function () { G.maskClose(); });
}

function lastBetData(json) {

    if (json.lastBetList && json.lastBetList.length > 0) {

        $("#leftBox").find("span[id='print_mem']").html(json.lastBetList[0][0]);
        $("#leftBox").find("span[id='print_issue']").html(json.lastBetList[0][1]);
        $("#leftBox").find("span[id='print_time']").html(json.lastBetList[0][2]);
        $("#leftBox").find("span[id='print_no']").html(json.lastBetList[0][3]);

        var htmlData = "<tr><td>号码</td><td>赔率</td><td>金额</td></tr>";
        var totalMoney = 0;
        for (var n = 1; n < json.lastBetList.length; n++) {
            var arr = json.lastBetList[n].split(":");
            htmlData += "<tr><td>" + getDwNameByType(arr[0]) + "</td><td>" + arr[2] + "</td><td>" + arr[1] + "</td></tr>";
            totalMoney += parseFloat(arr[1]);
        }

        var pages = json.lastBetList[0][4];
        var curpage = json.lastBetList[0][5];

        // htmlData += "<tr><td colspan='3'><div id='last_page'></div></td></tr>";

        htmlData += "<tr><td colspan='3'>总笔：<span class='red'>" + (json.lastBetList.length - 1) + "</span>总金额：<span class='red'>" + totalMoney + "</span></td></tr>";
        htmlData += "<tr><td colspan='3'>第" + json.lastBetList[0][1] + "期，1天内有效！！！</td></tr>";
        htmlData += "<tr><td colspan='3'><input id='clear-lastbet' class='btn grayBtn' type='button' value='清除'>" +
            "<input id='print-lastbet' class='btn hotBtn disSubmit' type='button' value='打印'></td></tr>"

        $("#last_list").html(htmlData);


        $("#clear-lastbet").unbind("click").click(function () {
            lastBetData(json);
            G.ajax("lastBets&page=-1", function (json) {

            });
        });

        $("#print-lastbet").unbind("click").click(function () {

            // parent.location.href = "print?t=" + __sysinfo.autoTid;
            //window.open("print?t=" + __sysinfo.autoTid);

            var bdhtml = window.document.body.innerHTML;
            window.document.body.innerHTML = $("#leftBox").html(); //把需要打印的指定内容赋给body.innerHTML
            window.print(); //调用浏览器的打印功能打印指定区域
            window.document.body.innerHTML = bdhtml; // 最后还原页面
            window.location.reload();

        });


    } else {
        $("#last_list").html("");
    }
}


function newGameData(msg, printAry) {
    if (msg.usableCredit) {
        $("#usableCreditSpan").html(msg.usableCredit);
    }

    if (msg.credit) {
        $("#creditSpan").html(msg.credit);
    }

    if (msg.oddsList) {
        for (var i in msg.oddsList) {
            $("#gameBox li[data-sort='" + i + "'] span.p a.oddsEvent").html(msg.oddsList[i]);
            if (msg.bianseList && msg.bianseList[i])
                $("#gameBox li[data-sort='" + i + "'] span.p a.oddsEvent").attr("style", "color: blue");

        }
    }
    if (msg.putResult) {
        var result = [], on;
        for (var i = 0; i < msg.putResult.length; i++) {
            on = i % 2 == 0 ? "on" : "";
            result.push("<li class='" + on + "'>" + msg.putResult[i] + "</li>");
        }
        if (result.length > 0) {
            $("#putResult").html(result.join(""));
        }
    }
    container(printAry);
}
function container(printAry) {
    var myDiv = "<div id='tip_container' class='container tip_container' style='width: 120px; margin-left:-55px; margin-top:55px;display:block'><div id='tip' class='success mtip'><i class='micon'></i><span id='tsc'>下注成功！</span><i id='mclose' class='mclose'></i></div></div>";
    $("#tip_container").remove();
    $("body").append(myDiv);
    setTimeout(function () {
        $("#tip_container").remove();
        if (printAry && printAry.length > 0) {
            var ary = [], key;
            for (var i = 0; i < printAry.length; i++) {
                key = printAry[i].split(":");
                ary.push(encodeURI("【" + key[5] + "】<br />【第" + key[6] + "期】<br />" + key[1] + "【" + key[2] + "】 @ <strong class=\"red\"> " + key[3] + "</strong><br />下注金额：<strong class=\"blue\">" + key[4] + "</strong>"));
            }
            myPrint(null, ary.join("êêê"));
        }
    }, 500);
    $(".rightBox div.left li").removeClass("active");//.removeAttr("style");
    $(".rightBox div.right ul").removeClass("active");
    $(".rightBox div.left li[name='putResult']").addClass("active");
    $(".rightBox div.right #putResult").addClass("active");
}
function myPrint(obj, ary) {
    var p = ary == undefined ? encodeURI($(obj).parent("p").find("label").html()) : ary;
    var content = "<iframe class='lineMain' style='width:280px;height:320px;' scrolling='auto' frameborder='0' src='/Member/Print.htm?data=" + p + "'></iframe>";
    G.alert({ title: "账单打印", content: content, ok: function () { return true; } });
}
function getDWTypeByName( name){
    name = name.toUpperCase();
    if (name.length == 4) name = name + "X";
    //一字定
    if (name.match("\\dXXXX")){
        return parseInt(name[0]) + 1;
    } else if (name.match("X\\dXXX")){
        return parseInt(name[1])  + 15;
    }else if (name.match("XX\\dXX")){
        return parseInt(name[2]) + 29;
    }else if (name.match("XXX\\dX")){
        return parseInt(name[3]) + 43;
    }else if (name.match("XXXX\\d")){
        return parseInt(name[4]) + 57;
    }
    //二字定
    else if (name.match("\\d{2}XXX")){
        return 108 + parseInt(name[0]) * 10 + parseInt(name[1]);
    }else if (name.match("\\dX\\dXX")){
        return 208 + parseInt(name[0]) * 10 + parseInt(name[2]);
    }else if (name.match("\\dXX\\dX")){
        return 308 + parseInt(name[0]) * 10 +parseInt(name[3]);
    }else if (name.match("\\dXXX\\d")){
        return 408 + parseInt(name[0]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{2}XX")){
        return 508 + parseInt(name[1]) * 10 + parseInt(name[2]);
    }else if (name.match("X\\dX\\dX")){
        return 608 + parseInt(name[1]) * 10 + parseInt(name[3]);
    }else if (name.match("X\\dXX\\d")){
        return 708 + parseInt(name[1]) * 10 + parseInt(name[4]);
    }else if (name.match("XX\\d{2}X")){
        return 808 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("XX\\dX\\d")){
        return 908 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("XXX\\d\\d")){
        return 1008 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    //三字定
    else if (name.match("\\d{3}XX")){
        return 1108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[2]);
    }else if (name.match("\\d{2}X\\dX")){
        return 2108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[3]);
    }else if (name.match("\\d{2}XX\\d")){
        return 3108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[4]);
    }else if (name.match("\\dX\\d{2}X")){
        return 4108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("\\dX\\dX\\d")){
        return 5108 + parseInt(name[0]) * 100 + parseInt(name[2]) *10 + parseInt(name[4]);
    }else if (name.match("\\dXX\\d{2}")){
        return 6108 + parseInt(name[0]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{3}X")){
        return 7108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    }else if (name.match("X\\d{2}X\\d")){
        return 8108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\dX\\d{2}")){
        return 9108 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("XX\\d{3}")){
        return 10108 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    else if (name.match("\\d{4}X")){
        return 11108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) *  10 + parseInt(name[3]);
    }else if (name.match("\\d{3}X\\d")){
        return 21108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    }else if (name.match("\\d{2}X\\d{2}")){
        return 31108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("\\dX\\d{3}")){
        return 41108 + parseInt(name[0]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }else if (name.match("X\\d{4}")){
        return 51108 + parseInt(name[1]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }


    return 0;

}
module.exports = {
    gamedata,
    game_loading_wrap,
    gameBoxTitleClick,
    gameTitleClick,
    loadOdds,
    clsort,
    addFanResult,
    addCqlResult,
    bindGameFun,
    selectDSDX,
    selectDW,
    enachRadioPoint,
    myWarp,
    gameHxSubmit,
    gameSubmit,
    dataSubmit,
    lastBetData,
    newGameData,
    container,
    myPrint,
    G
}
